import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { showToast } from '../Common/Messages';

const Banners = () => {
    const history = useNavigate();
    const LoginStates = useSelector(state => state.login);
    const moveTo = (path, state) => {
        if (LoginStates.userId === '') {
            showToast('warning', "로그인 후 이용해주세요.");
            history('/Login');
        } else {
            if (state == null)
                history(`/${path}`);
            else
                history(`/${path}`, { state: state });
        }
    }
    return (
        <section className="banner-wrap">
            <div className="inquiry" onClick={() => moveTo('MyPage/topicList', { current: 'topicList', locationFrom: 'home', locationCurrent: 'topicWrite' })}>
                <h4 className="banner-title">1:1 문의</h4>
                <p className="banner-sub">궁금한 점을 문의해 보세요.</p>
            </div>
            <div className="levelup" onClick={() => moveTo('education/levelup')}>
                <h4 className="banner-title">개발자 역량강화</h4>
                <p className="banner-sub">개발자들을 위한<br />실전 역량 향상 지침서</p>
            </div>
            <div className="guide" onClick={() => moveTo('guide/devrules')}>
                <h4 className="banner-title">개발 규칙 가이드</h4>
                <p className="banner-sub">더 나은 협업을 위한<br />개발 규칙 가이드라인</p>
            </div>
            <div className="FAQ" onClick={() => moveTo('FAQ')}>
                <h4 className="banner-title">FAQ</h4>
                <p className="banner-sub">가장 많이 온 문의에 대해 답변드립니다.</p>
            </div>
        </section>
    );
}

export default Banners;